// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import {getMessaging, getToken} from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBUXuGn04GZ9BqNCXVZ-6ict1OYTKziG-M",
  authDomain: "fixitindia-f0dca.firebaseapp.com",
  projectId: "fixitindia-f0dca",
  storageBucket: "fixitindia-f0dca.firebasestorage.app",
  messagingSenderId: "430143331842",
  appId: "1:430143331842:web:36663e42e8bcc6b3c6911b",
  measurementId: "G-K5CXNLK8MD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
//const analytics = getAnalytics(app);

export const messaging = getMessaging(app);

export const generateToken = async () => {
  const permission= await Notification.requestPermission();
  console.log(permission);
  if (permission === "granted") {
 const token = await getToken(messaging, {
    vapidKey: "BHrf2Oatq7KTwKChrnMJ3SLIjRfYLb52sFDtbHZD1cLhcd3RmnNQCEU-L_ULQUlT_ZZ4wVG0nfvGvJQWhqZ-D6c",
  }) 
  console.log(token);
  }
 
}